import { useRef, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home, Celebrity, DetailedServicesPage } from './pages';
import { Navbar, EventRegistrationPopup, ContactPopup } from './component';
import './App.css';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { IconButton, useMediaQuery } from '@mui/material';

function App() {
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [openContact, setOpenContact] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const isMobile = useMediaQuery('(max-width:768px)');

  useEffect(() => {
    // setTimeout(() => {
    //   setOpen(true);
    // }, 1000 * 2);
    const handleScroll = () => {
      if (window.scrollY > 100) {
        // Show the button when scrolled down 100px
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClickOpen = () => {
    setOpenContact(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOpenContact(false);
  };

  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({
      behavior: 'smooth', // Smooth scrolling
      block: 'center' // Center the section in the viewport
    });
  };

  const handleScrollTo = (id, adjustTopValue = -50) => {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = adjustTopValue; // Adjust this value based on your header height
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };

  return (
    <Router>
      <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
        {!isMobile && (
          <div
            style={{
              width: '30px',
              height: '30px',
              borderTopLeftRadius: '4px',
              borderBottomLeftRadius: '4px',
              position: 'fixed',
              top: '50%',
              right: '0',
              background: '#1c7b7b',
              zIndex: 10000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <IconButton style={{ color: 'black' }} onClick={handleClickOpen}>
              <ContactPageIcon color="black" />
            </IconButton>
          </div>
        )}
        {isMobile && (
          <div
            style={{
              position: 'fixed',
              bottom: '0',
              width: '100%',
              background: '#1c7b7b',
              color: 'white',
              textAlign: 'center',
              padding: '20px 10px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              zIndex: 10000
            }}
            onClick={handleClickOpen}
          >
            Enquire Now
          </div>
        )}
        {showButton && (
          <div
            style={{
              width: '30px',
              height: '30px',
              borderRadius: '50%',
              position: 'fixed',
              bottom: '20px', // Adjusted for bottom-right corner
              right: '20px',
              background: '#1c7b7b',
              zIndex: 10000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
              cursor: 'pointer'
            }}
          >
            <IconButton
              style={{ color: 'white' }}
              fontSize="small"
              onClick={() => {
                handleScrollTo('home-section');
              }}
            >
              <ArrowUpwardIcon />
            </IconButton>
          </div>
        )}
        <Navbar />
        {open && (
          <EventRegistrationPopup open={open} handleClose={handleClose} />
        )}
        {openContact && (
          <ContactPopup
            open={openContact}
            handleClose={() => setOpenContact(false)}
          />
        )}
        <div style={{ height: '90%', width: '100%' }}>
          <Routes>
            <Route
              exact
              path="/"
              element={
                <Home
                  refs={{ homeRef, contactRef, aboutRef }}
                  scrollToSection={scrollToSection}
                />
              }
            />
            <Route path="/celebrities" element={<Celebrity />} />
            <Route path="/services/:id" element={<DetailedServicesPage />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
